import { forwardRef, ReactNode } from "react";
import { useDropdownContext } from "../../dropdown";
import * as SC from "./option.styles";

export interface SelectOption {
  id: string;
  label: string;
  value: any;
}

export interface OptionProps {
  checked: boolean;
  children: ReactNode;
  id: string;
  label: string;
  onCheckedChange?: (checked: boolean, selectedOption: SelectOption) => void;
  value: any;
}

export const Option = forwardRef<HTMLDivElement, OptionProps>(
  ({ checked, children, id, label, onCheckedChange, value }, ref) => {
    const { toggleSelection } = useDropdownContext();

    return (
      <SC.OptionWrapper
        checked={checked}
        ref={ref}
        onClick={() => {
          onCheckedChange?.(checked, {
            id,
            label,
            value,
          });
          toggleSelection(checked, {
            id,
            label,
            value,
          });
        }}
      >
        {children}
      </SC.OptionWrapper>
    );
  }
);
